export default __webpack_public_path__ + "static/articles-lutein-sinia-svetlina-253e919f43dca2f0215d74fdb95bf4d8.jpg";